import * as App from 'app.js';

export const searchBar = () => {
  const elements = document.querySelectorAll('[data-load-search-bar]');

  elements.forEach((el) => {

    const form = el.closest('#search');

    const inputSearch = form.querySelector('input#search_query');
    const results = form.querySelector('.suggestions');

    const inputLocation = form.querySelector('input#search_location');

    const tag_id = form.querySelector("#search_tag_id");
    const category_id = form.querySelector("#search_category_id");
    const group_id = form.querySelector("#search_group_id");

    const submits = form.querySelectorAll("input[type='submit']"); // We have different submits desktop/mobile :(
    const vertical_id = document.querySelector('[data-vertical-id]').dataset.verticalId;

    App.loadAutocomplete(inputSearch, results, function (value) { return "/suggestions?query=" + value + "&vertical_id=" + vertical_id; })

    inputSearch.addEventListener('focus', function () {
      this.select()
    });

    inputSearch.addEventListener('selected-suggestion', () => {
      if(inputLocation.value == '') {
        inputLocation.focus();
      }
    })


    submits.forEach(function (submit) {
      submit.addEventListener('click', function (event) {
        // We need either a query string OR a Tag OR a Category AND a location to actually search for listings
        if (!inputSearch.value && !tag_id.value && !category_id.value && !group_id.value) {
          event.preventDefault();
          inputSearch.focus();
          inputSearch.classList.add('invalid');
          inputSearch.addEventListener('transitionend', (evt) => {
            inputSearch.classList.remove('invalid')
          })
        }
      });
    });
  })
};
